import { Ajax2 } from '@shared/Ajax';
import { ComparisonResponse, ComparisonResponseSchema, ComparisonApiParams as ComparisonApiParams, SaveVolumeApiParams, MergeVolumeApiParams, StockpileResponseSchema, StockpileResponse, demApiParams, VariationApiParams } from './models';
import { ModelService } from '@shared/models/model-service';

// Determine API URL
const vizBaseUrl = ModelService.getVizApiBaseUrl()
//const vizBaseUrl = 'http://localhost:8000/viz/v1'
const kuuraBaseUrl = kuura.getServerDomain()
//const kuuraBaseUrl = 'http://localhost:8080/kuura'

export async function stockpileApi(params: demApiParams): Promise<StockpileResponse> {
    const apiUrl = `${vizBaseUrl}/vol-calc/stockpile`
    const formData = stockpileForm(params);
    const response = await Ajax2({
        url: apiUrl,
        data: formData,
        method: 'POST',
        useToken: true,
        contentType: 'multipart/form-data',
        timeout: 60000,
    })
    return StockpileResponseSchema.parse(response)
}

export async function comparisonApi(params: ComparisonApiParams): Promise<ComparisonResponse> {
    const apiUrl = `${vizBaseUrl}/vol-calc/comparison`
    const formData = comparisonForm(params);
    const response = await Ajax2({
        url: apiUrl,
        data: formData,
        method: 'POST',
        useToken: true,
        contentType: 'multipart/form-data',
        timeout: 60000,
    })
    return ComparisonResponseSchema.parse(response)
}

export async function VariationApi(params: VariationApiParams) {
    const apiUrl = `${vizBaseUrl}/vol-calc/variation`
    const formData = VariationForm(params);
    return Ajax2({
        url: apiUrl,
        data: formData,
        method: 'POST',
        useToken: true,
        contentType: 'multipart/form-data',
        timeout: 30000
    })
}

export async function mergeVolumeApi(params: MergeVolumeApiParams) {
    const apiUrl = `${vizBaseUrl}/vol-calc/merge`
    return Ajax2({
        url: apiUrl,
        data: params,
        method: 'POST',
        useToken: true,
        contentType: 'json',
        timeout: 30000
    })
}

export async function saveVolumeApi(params: SaveVolumeApiParams) {
    const apiUrl = `${kuuraBaseUrl}/v1/vol-crud/save`
    const formData = addVolumeForm(params);
    return Ajax2({
        url: apiUrl,
        data: formData,
        method: 'POST',
        useToken: true,
        contentType: 'multipart/form-data',
        timeout: 30000
    })
}

export const getVolumesByProject = async(project_uuid) => {
    const apiUrl = `${kuuraBaseUrl}/vol-crud/project/${project_uuid}`
    return Ajax2({
        url: apiUrl,
        method: 'GET',
        useToken: true,
    })
}

function stockpileForm(params: demApiParams) {
    const { tolerance, area, kml_segment, dem_url, customBaseHeight } = params;
    const formData = new FormData();
    const formFields = {
        'project_uuid': kuura.getProjectUuid(),
        'area': area.toString(),
        'dem_s3_key': dem_url,
        'tolerance': tolerance.toString(),
        'file': kml_segment,
    };
    Object.entries(formFields).forEach(([key, value]) => formData.append(key, value));

    if (customBaseHeight) {
        formData.append('base_height', customBaseHeight.toString());
    }

    return formData;
}

function comparisonForm(params: ComparisonApiParams) {
    const { cacheUuid, area, kml_segment, tolerance, target, reference, variation } = params;
    console.log(variation)
    const formData = new FormData();
    const formFields = {
        'project_uuid': kuura.getProjectUuid(),
        'cache_uuid': cacheUuid,
        'area': area.toString(),
        'from_type': target.surfaceType,
        'from_model_uuid': target.surfaceModelUuid,
        'from_s3_key': target.surfaceDemUrl,
        'to_type': reference.surfaceType,
        'to_model_uuid': reference.surfaceModelUuid,
        'to_s3_key': reference.surfaceDemUrl,
        'tolerance': tolerance.toString(),
        'color': variation.color.toString(),
        'min_z': variation.min_z.toString(),
        'max_z': variation.max_z.toString(),
        'file': kml_segment,
    };
    Object.entries(formFields).forEach(([key, value]) => formData.append(key, value));
    return formData;
}

function VariationForm(params: VariationApiParams) {
    const { reference, target, file, tolerance } = params;
    const formData = new FormData();
    const formFields = {
        'project_uuid': kuura.getProjectUuid(),
        'from_type': target.surfaceType,
        'from_model_uuid': target.surfaceModelUuid,
        'from_s3_key': target.surfaceDemUrl,
        'to_type': reference.surfaceType,
        'to_model_uuid': reference.surfaceModelUuid,
        'to_s3_key': reference.surfaceDemUrl,
        'file': file,
        'tolerance': tolerance.toString(),
    };
    Object.entries(formFields).forEach(([key, value]) => formData.append(key, value));
    return formData;
}

function addVolumeForm(params: SaveVolumeApiParams) {
    const { folderUuid, fillVolume, cutVolume, baseHeight, tolerance, area, file, target, reference } = params;
    const formData = new FormData();
    const formFields = {
        'project_uuid': kuura.getProjectUuid(),
        'folder_uuid': folderUuid,
        'area': area.toString(),
        'fill_volume': fillVolume.toString(),
        'cut_volume': cutVolume.toString(),
        ...(baseHeight
            ? { 'base_height': baseHeight.toString() }
            : {}
        ),
        'tolerance': tolerance.toString(),
        'kml_file': file,
        'from_type': target.surfaceType,
        'from_model_uuid': target.surfaceModelUuid,
        'from_s3_key': target.surfaceDemUrl,
        'to_type': reference.surfaceType,
        'to_model_uuid': reference.surfaceModelUuid,
        'to_s3_key': reference.surfaceDemUrl,
    };
    Object.entries(formFields).forEach(([key, value]) => formData.append(key, value));
    return formData;
}
